import { useState, useEffect } from 'react';
import axios from 'axios';

export interface VacationType {
  new_axsvacationtypeid: string;
  new_name: string;
  new_requireapproval: boolean;
  new_requiredocuments: boolean;
  new_titlebg: string;
}

export const useVacationTypes = () => {
  const [vacationTypes, setVacationTypes] = useState<VacationType[]>([]);
  const [loadingVacationTypes, setLoadingVacationTypes] =
    useState<boolean>(false);

  const getVacationTypes = async () => {
    try {
      const response = await axios.get('api/vacation-types');
      setLoadingVacationTypes(true);
      const vacations = response.data;

      setVacationTypes(vacations);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingVacationTypes(false);
    }
  };

  useEffect(() => {
    getVacationTypes();
  }, []);

  const mappedVacationTypes = vacationTypes.map((vacationType) => ({
    key: vacationType.new_name,
    text: vacationType.new_name.replace('Time-off', 'Time off'),
  }));

  return { vacationTypes, loadingVacationTypes, mappedVacationTypes };
};
